
<template>
  <BaseNew
    @new-confirm-action="createEntry"
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    width="70%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    :inlineAddButton="inlineAddButton"
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"
        :extraData="extraData"
        :modelNameSingular="modelNameSingular"
      />
    </template>
    
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from './form.vue';
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      entry: null,
      formErrors: [],
      extraData: null,
    };
  },
  props: {
    inlineAddButton: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  methods: {
    loadServerEntry: function() {
      this.error = null;
      this.entry = {}
      this.loading=false;
      // this.loading = true;
      // this.$apollo
      //   .query({
      //     query: LOAD_NEW_ITEM_WEIGHT_QUERY,
      //     fetchPolicy: "no-cache"
      //   })
      //   .then(response => {
      //     this.entry = response.data.accountContext.itemWeight;
      //     this.extraData = response.data;
      //   })
      //   .catch(response => console.log(response))
      //   .finally(() => (this.loading = false));

    },
    createServerEntry: function(itemWeight) {
      // console.log("SUBCULTURE", itemWeight, this.entry.validations, this.deepFilterEntryWithAllowedFieldsForMutation(itemWeight, this.entry.validations));
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: CREATE_ITEM_WEIGHT_MUTATION,
          variables: {
            input: itemWeight
          }
        })
        .then(response => {
          var errors = response.data.createItemWeight.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseNew.closeDialog();
            this.$emit("entry-created", response.data.createItemWeight.itemWeight);
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    createEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.createServerEntry(this.entry);
        this.resetForm();
      }
    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_NEW_ITEM_WEIGHT_QUERY = gql `
  {
    accountContext{
      itemWeight {
        id
        validations
      }
    } 
  }
`;

const CREATE_ITEM_WEIGHT_MUTATION = gql `
  mutation($input: ItemWeightCreateInputObject!) {
    createItemWeight(input: $input) {
      itemWeight {  
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>

